import React, { useEffect, useState } from 'react';
import DataTable from '../../../components_shared/DataTable';
import api, { dispatchAPI, inventoryAPI, financeAPI, apiBaseUrl } from '../../../utils/api';
import Swal from 'sweetalert2';

export default function DispatchNotesPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [viewNote,setViewNote]=useState(null);
  const [editId,setEditId]=useState(null);
  const [editStatus,setEditStatus]=useState('DISPATCHED');
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    setLoading(true);
    const load = async () => {
      try {
        const res = await api.get('/api/v1/inventory/dispatch-notes', { params:{ page:0, size:50, sort:'id,desc'} });
        setRows(res.data.content || []);
      } catch (err) {
        setError(err.response?.data?.message || err.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [reloadKey]);

  const handleGenerateInvoice = async (noteId) => {
    try {
      await financeAPI.generateFromDispatch({ dispatchNoteId: noteId });
      Swal.fire('Success', 'Invoice generated successfully.', 'success');
      setReloadKey(k => k + 1);
    } catch (err) {
      Swal.fire('Error', err.response?.data?.error || err.message, 'error');
    }
  };

  const columns = [
    { accessorKey: 'id', header: 'ID' },
    { accessorKey: 'workOrderNo', header: 'Work Order' },
    { accessorKey: 'referenceNo', header: 'Ref #' },
    { accessorKey: 'classLevel', header: 'Class' },
    { accessorKey: 'medium', header: 'Medium' },
    { accessorKey: 'totalQuantity', header: 'Qty', cell:({row})=> row.original.totalQuantity ?? row.original.quantity },
    { accessorKey: 'truckNumber', header: 'Truck #' },
    { id:'view', header:'View', cell:({row})=> (<button className="eduss-global-action-btn view" onClick={async()=>{
        const res=await inventoryAPI.getDispatchNote(row.original.id); setViewNote(res.data);
      }}>👁️</button>)},
    { id:'pdf', header:'PDF', cell:({row})=> (
        <button className="eduss-global-action-btn view" onClick={()=>window.open(`${apiBaseUrl}/api/v1/inventory/dispatch-notes/${row.original.id}/pdf`,'_blank')}>📄</button>
      )},
    { accessorKey: 'status', header: 'Status', cell: ({ row }) => (
        <span className={`badge ${row.original.status==='DISPATCHED'?'bg-secondary':row.original.status==='ARRIVED_GATE'?'bg-info':row.original.status==='IN_QC'?'bg-warning':'bg-success'}`}>{row.original.status}</span>
      ) },
    { id:'act', header:'Actions', cell:({row})=> (
        <>
        <button className="btn btn-outline-secondary btn-sm me-1" title="Edit Status" onClick={()=>{setEditId(row.original.id);setEditStatus(row.original.status);}}>
          ✏️
        </button>
        {row.original.status==='ARRIVED_GATE' && (
          <button className="btn btn-warning btn-sm" onClick={async()=>{
            try{ await dispatchAPI.provisional(row.original.id); setReloadKey(k => k + 1); }
            catch(e){ alert(e.response?.data?.message||e.message);} }}>Provisional</button>) }
        {row.original.status==='RECEIVED_FINAL' && (
          <button className="btn btn-primary btn-sm ms-1" title="Generate Invoice" onClick={()=>handleGenerateInvoice(row.original.id)}>
            💰 Invoice
          </button>
        )}
        </>
      )},
  ];

  if (loading) return <p>Loading...</p>;
  if (error) return <div className="alert alert-danger">{error}</div>;

  return (
    <div className="inventory-page">
      <div className="premium-card inventory-page-card">
      <div className="inventory-page-toolbar">
        <h2>Dispatch Notes</h2>
        <div className="inventory-page-actions">
          <button className="btn btn-outline-secondary btn-sm" onClick={()=>exportCsv(rows)}>Export CSV</button>
          <button className="btn btn-outline-secondary btn-sm" onClick={sampleCsv}>Sample CSV</button>
        </div>
      </div>
      <DataTable data={rows} columns={columns} />
      </div>

      {viewNote && (
        <div className="eduss-global-modal-overlay" onClick={()=>setViewNote(null)}>
          <div className="eduss-global-modal eduss-admin-form-modal" onClick={e=>e.stopPropagation()}>
            <div className="eduss-global-modal-header"><h3>Dispatch Note</h3><button onClick={()=>setViewNote(null)}>&times;</button></div>
            <div className="eduss-global-modal-content" style={{maxHeight:'70vh',overflowY:'auto'}}>
              <div className="grid-2" style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                <div className="card shadow-sm p-2">
                  <h5>Header</h5>
                  <table className="eduss-global-view-table"><tbody>
                    <tr><th>Ref #</th><td>{viewNote.referenceNo}</td></tr>
                    <tr><th>Work Order</th><td>{viewNote.workOrderNo}</td></tr>
                    <tr><th>Status</th><td>{viewNote.status}</td></tr>
                    <tr><th>Total Qty</th><td>{viewNote.totalQuantity||viewNote.quantity}</td></tr>
                    <tr><th>Created</th><td>{viewNote.createdAt}</td></tr>
                  </tbody></table>
                </div>
                <div className="card shadow-sm p-2">
                  <h5>Shipment</h5>
                  <table className="eduss-global-view-table"><tbody>
                    <tr><th>Truck #</th><td>{viewNote.truckNumber}</td></tr>
                    <tr><th>Driver</th><td>{viewNote.driverName}</td></tr>
                    <tr><th>CNIC</th><td>{viewNote.driverCnic}</td></tr>
                    <tr><th>ETA</th><td>{viewNote.eta}</td></tr>
                    <tr><th>Class/Medium</th><td>{viewNote.classLevel} / {viewNote.medium}</td></tr>
                  </tbody></table>
                </div>
              </div>

              {viewNote.items && viewNote.items.length>0 && (
                <>
                  <h4 style={{marginTop:16}}>Items</h4>
                  <table className="eduss-global-datatable" style={{minWidth:'700px'}}>
                    <thead><tr><th>#</th><th>Book Code</th><th>Book Name</th><th>Dispatch Qty</th><th>Balance Qty</th></tr></thead>
                    <tbody>
                      {viewNote.items.map((it,idx)=>(
                        <tr key={it.id}><td>{idx+1}</td><td>{it.book?.bookCode||it.bookId}</td><td>{it.book?.name||'-'}</td><td>{it.dispatchQty}</td><td>{it.balanceQty}</td></tr>
                      ))}
                      <tr style={{fontWeight:600}}><td colSpan={3} style={{textAlign:'right'}}>Total</td><td>{viewNote.totalQuantity||viewNote.quantity}</td><td></td></tr>
                    </tbody>
                  </table>
                </>
              )}

              <div style={{marginTop:12,display:'flex',gap:8}}>
                <a className="btn btn-sm btn-outline-primary" href={`${apiBaseUrl}/api/v1/inventory/dispatch-notes/${viewNote.id}/pdf`} target="_blank" rel="noreferrer">Download PDF</a>
                <button className="btn btn-sm btn-outline-secondary" onClick={()=>window.print()}>Print</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* edit modal */}
      {editId && (
        <div className="eduss-global-modal-overlay" onClick={()=>setEditId(null)}>
          <div className="eduss-global-modal eduss-admin-form-modal" onClick={e=>e.stopPropagation()} style={{maxWidth:400}}>
            <div className="eduss-global-modal-header"><h4>Edit Status</h4><button onClick={()=>setEditId(null)}>&times;</button></div>
            <div className="p-3">
              <div className="mb-3">
                <label className="form-label">Status</label>
                <select className="form-select" value={editStatus} onChange={e=>setEditStatus(e.target.value)}>
                  {['DISPATCHED','ARRIVED_GATE','IN_QC','RECEIVED_FINAL','QC_REJECTED'].map(s=> <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
              <button className="btn btn-primary" onClick={async()=>{
                try{
                  await api.patch(`/api/v1/inventory/dispatch-notes/${editId}/status`,{status:editStatus});
                  setEditId(null); setReloadKey(k => k + 1);
                }catch(e){ alert(e.response?.data?.message||e.message);} } }>Save</button>
            </div>
          </div>
        </div>) }
    </div>
  );

  function exportCsv(list){
    if(!list.length){ alert('No data'); return; }
    const header=['id','referenceNo','workOrderNo','classLevel','medium','quantity','truckNumber','driverName','driverCnic','eta','status'];
    const lines=[header.join(',')];
    list.forEach(r=>{ lines.push(header.map(h=>r[h]??'').join(',')); });
    downloadCsv(lines.join('\n'),'dispatch_notes_export.csv');
  }

  function sampleCsv(){
    const header='id,referenceNo,workOrderNo,classLevel,medium,quantity,truckNumber,driverName,driverCnic,eta,status\n';
    const example=',DN-000001,WO-001,Kachi,ENG,10,ABC-123,Ali,42101-1234567-9,2025-09-20T10:00,DISPATCHED\n';
    downloadCsv(header+example,'dispatch_notes_sample.csv');
  }

  function downloadCsv(text,filename){
    const blob=new Blob([text],{type:'text/csv'}); const url=URL.createObjectURL(blob);
    const a=document.createElement('a'); a.href=url; a.download=filename; a.click(); URL.revokeObjectURL(url);
  }
}
